export enum SessionStorageMode
{
    NATIVE,
    BROWSER
}